import React from "react"
import MetaTags from 'react-meta-tags';
import { Link ,useParams} from "react-router-dom"
import {
  Container,
  Card,
  CardBody,
  Col,
  Form,
  Input,
  Label,
  Row,
  Spinner,
} from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

// import images
import img1 from "../../assets/images/small/img-2.jpg"
import avtar1 from "../../assets/images/users/avatar-2.jpg"
import { useQuery } from "react-query";
import { getJournalById } from "helpers/fakebackend_helper";
import { IMAGE_BASE_URL } from "constants/imageUrl";



const BlogDetails = () => {

  const { id } = useParams();
  const {data, isLoading} = useQuery({
    queryKey: ['journal', id],
    queryFn: () => getJournalById(id)
  })
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Journal Details   </title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title="Journal" breadcrumbItem="Journal Details" />
          <Row>
            <Col lg={12}>
              <Card>
               
                <CardBody>
                {isLoading ? (
                  <div className="d-flex justify-content-center">
                    <Spinner color="primary" />
                  </div>
                ) : (
                  <div className="pt-3">
                    <div className="row justify-content-center">
                      <div className="col-xl-8">
                        <div>
                          <div className="text-center">
                             
                            <h3>{data?.journal?.name.charAt(0).toUpperCase() + data?.journal?.name.slice(1)}</h3>
                            
                          </div>

                          <hr />
                          <div className="text-center">
                            <Row>
                              <Col sm={4}>
                                <div>
                                  <p className="text-muted mb-2">Categories</p>
                                  <h5 className="font-size-15">Images</h5>
                                </div>
                              </Col>
                              <Col sm={4}>
                                <div className="mt-4 mt-sm-0">
                                  <p className="text-muted mb-2">Date</p>
                                  <h5 className="font-size-15">
                                    <i className="mdi mdi-calendar me-1"></i>
                                    {new Date(data?.journal?.created_at).toLocaleString()}
                                  </h5>
                                </div>
                              </Col>
                              <Col sm={4}>
                                <div className="mt-4 mt-sm-0">
                                  <p className="text-muted mb-2">Post by</p>
                                  <h5 className="font-size-15">{data?.journal?.created_by?.name}</h5>
                                </div>
                              </Col>
                            </Row>
                          </div>
                          <hr />

                          <div className="my-5">
                            <img
                              src={`${IMAGE_BASE_URL}/${data?.journal?.journal_photos[0]?.photo_url}`}
                              style={{ width: "80%" }}
                              alt=""
                              className="img-thumbnail mx-auto d-block"
                            />
                          </div>

                          {/* <hr /> */}

                          <div className="mt-4">
                            {/* <div className="text-muted font-size-14 mb-5">
                              <p className="larger-font-size" style={{   fontSize: 'larger' }} >
                                {data?.journal?.content}
                              </p>
                            </div> */}
                            <blockquote className="p-4 border-light border rounded mb-4">
                                  <div className="d-flex">
                                    <div className="me-3">
                                      <i className="bx bxs-quote-alt-left text-dark font-size-24"></i>
                                    </div>
                                    <div>
                                    <p className="larger-font-size" style={{   fontSize: 'larger' }} >
                                {data?.journal?.content}
                              </p>
                                    </div>
                                  </div>
                                </blockquote>

                            {data?.journal?.journal_photos.slice(1).map((photo, index) => (
                              <div key={index} className="mb-4">
                                <img
                                  src={`${IMAGE_BASE_URL}/${photo.photo_url}`}
                                  alt=""
                                  style={{ width: "80%" }}
                                  className="img-thumbnail mx-auto d-block"
                                />
                              </div>
                            ))}
                            <hr />

                            <div className="mt-5">
                              <h5 className="font-size-15">
                                <i className="bx bx-message-dots text-muted align-middle me-1"></i>{" "}
                                Comments :
                              </h5>

                              <div>
                                <div className="d-flex py-3">
                                  <div className="avatar-xs me-3">
                                    <div className="avatar-title rounded-circle bg-light text-primary">
                                      <i className="bx bxs-user"></i>
                                    </div>
                                  </div>
                                  <div className="flex-grow-1">
                                    <h5 className="font-size-14 mb-1">
                                      Bot {" "}
                                      <small className="text-muted float-end">
                                        1 hr Ago
                                      </small>
                                    </h5>
                                    <p className="text-muted">
                                     comming soon
                                    </p>
                                    <div>
                                      <Link to="#" className="text-success">
                                        <i className="mdi mdi-reply"></i> Reply
                                      </Link>
                                    </div>
                                  </div>
                                </div>

                                 
                              </div>
                            </div>

                            <div className="mt-4">
                              <h5 className="font-size-16 mb-3">Leave a Comment</h5>

                              <Form>
                                <Row>
                                   
                                </Row>

                                <div className="mb-3">
                                  <Label htmlFor="commentmessage-input">
                                    Comment
                                  </Label>
                                  <textarea
                                    className="form-control"
                                    id="commentmessage-input"
                                    placeholder="Your message..."
                                    rows="3"
                                  ></textarea>
                                </div>

                                <div className="text-end">
                                  <button
                                    type="button"
                                    className="btn btn-success w-sm"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </Form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default BlogDetails
